export default __webpack_public_path__ + "static/media/oxygen-saturation.3f95e7a6.png";